// extracted by mini-css-extract-plugin
module.exports = {"root":"base-carousel_root__2NTIc","wrapper":"base-carousel_wrapper__1Be0R","item":"base-carousel_item__Y1lZz"};